<template>
  <div>
    <!-- 面包屑导航 -->
    <div class="topNav">
      <div class="navFormWrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/homePage' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>字典列表</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button
          type="success"
          style="margin-left: 8vh"
          icon="el-icon-plus"
          @click="handleNewAdd"
          size="mini"
          >新增字典</el-button
        >
      </div>
    </div>

    <el-table
      :data="tableList"
      style="width: 100%; margin-top: 2vh"
      border
      size="mini"
      :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }"
    >
      <el-table-column prop="key" label="字典项" align="center" />
      <el-table-column prop="remark" label="中文名" align="center" />
      <el-table-column prop="value" label="取值" align="center" />
      <el-table-column fixed="right" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="handleClick(scope.row)"
            type="primary"
            size="small"
            icon="el-icon-edit"
          >
            修改
          </el-button>
          <el-button
            @click.native.prevent="singleDel(scope.row.id)"
            type="danger"
            size="small"
            icon="el-icon-delete"
          >
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :title="title"
      :visible.sync="addOrEditOpen"
      :close-on-click-modal="false"
      width="30%"
      class="global-dialog-position"
      :before-close="getout"
    >
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="字典名" prop="key">
              <el-input
                v-model="form.key"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="中文名" prop="key">
              <el-input
                v-model="form.remark"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="取值" prop="value">
              <el-input
                v-model="form.value"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="getout">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getdictList, deleteDict, addDict, editDict } from "../../api/dict";
export default {
  data() {
    return {
      tableList: [],
      addOrEditOpen: false,
      types: "",
      title: "",
      form: {},
      // 规则验证
      rules: {
        value: [{ required: true, message: "请输入取值", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.getdictLists();
  },
  methods: {
    getdictLists() {
      getdictList().then((res) => {
        console.log(res);
        this.tableList = res.data;
      });
    },
    // 重置
    reset() {
      this.form = {
        value: undefined,
        key: undefined,
      };
    },
    // 新增
    handleNewAdd() {
      this.title = "新增字典项";
      this.reset();
      this.types = "add";
      this.addOrEditOpen = true;
    },
    // 修改
    handleClick(row) {
      this.title = "修改";
      this.types = "edit";
      this.form = JSON.parse(JSON.stringify(row));
      this.addOrEditOpen = true;
    },
    // 取消
    getout() {
      this.addOrEditOpen = false;
      this.$refs.form.clearValidate();
    },
    // 确定
    submitForm() {
      this.$refs["form"].validate((vaild, err) => {
        if (vaild) {
          if (this.types == "add") {
            addDict(this.form).then((res) => {
              console.log(res);
              if (res.code !== 200) return this.$message.error("添加失败");
              this.$message.success("添加成功");
              this.addOrEditOpen = false;
              this.getdictLists();
            });
          } else {
            editDict(this.form).then((res) => {
              console.log(res);
              if (res.code !== 200) return this.$message.error("修改失败");
              this.$message.success("修改成功");
              this.addOrEditOpen = false;
              this.getdictLists();
            });
          }
        }
      });
    },
    // 删除
    singleDel(req) {
      console.log(req);
      this.$confirm("确定删除吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await deleteDict(req);
        if (res.code !== 200) return this.$message.error("删除失败!");
        this.$message.success("删除成功");
        this.getdictLists();
      });
    },
  },
};
</script>
<style scoped>
/deep/.el-table,
.el-table th,
.el-table td {
  border-radius: 10px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: 16px;
  font-family: Times, "Times New Roman";
  /* font-weight: 600; */
}
.topNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 20px 20px;
  border-radius: 10px;
}

.navFormWrapper {
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/dict/index.vue